module.exports = __webpack_public_path__ + "static/media/smart-buildings.f43125dc.jpg";